var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGame3Badge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 392,
    viewBox: "0 0 392 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 372",
    filter: "url(#filter0_d_573_74)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 196,
    cy: 192,
    r: 192,
    fill: "#BCD1AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M295.856 247.507L295.856 247.499V247.492C295.856 211.377 267.341 181.984 232.185 181.984C197.028 181.984 168.514 211.377 168.514 247.492C168.514 283.607 197.028 312.999 232.185 312.999C267.354 312.999 295.308 283.596 295.856 247.507ZM178.077 247.492C178.077 216.875 202.509 191.77 232.185 191.77C261.86 191.77 286.292 216.875 286.292 247.492C286.292 278.108 261.86 303.214 232.185 303.214C202.509 303.214 178.077 278.108 178.077 247.492Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M252.15 272.25L252.114 272.275L252.08 272.303C246.878 276.586 240.087 278.748 233.266 278.748C216.557 278.748 202.931 264.764 202.931 247.494C202.931 230.224 216.557 216.24 233.266 216.24C240.051 216.24 246.293 218.38 251.5 222.653C253.6 224.759 256.953 224.044 258.363 221.984C259.366 220.906 259.68 219.507 259.516 218.24C259.351 216.972 258.696 215.736 257.634 214.993C250.441 209.306 242.127 206.455 233.266 206.455C211.068 206.455 193.367 225.291 193.367 247.494C193.367 270.272 211.626 288.533 233.266 288.533C242.707 288.533 251.01 285.101 258.159 280.006L258.233 279.953L258.296 279.888C260.275 277.851 260.265 275.105 258.958 273.087L258.905 273.004L258.836 272.934C256.845 270.884 254.135 270.888 252.15 272.25Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M119.471 114.162L119.372 114.141H119.27H111.166C109.501 114.141 107.844 112.867 107.844 110.693V96.2341C107.844 94.4499 109.122 92.7854 111.166 92.7854H206.793C208.457 92.7854 210.115 94.0599 210.115 96.2341V111.249C210.115 113.033 208.836 114.698 206.793 114.698C204.053 114.698 202.011 116.841 202.011 119.59C202.011 122.339 204.053 124.483 206.793 124.483H214.897C216.561 124.483 218.219 125.757 218.219 127.932V142.946C218.219 144.731 216.94 146.395 214.897 146.395H206.793C204.053 146.395 202.011 148.539 202.011 151.288C202.011 154.037 204.053 156.18 206.793 156.18C208.457 156.18 210.115 157.455 210.115 159.629V170.751C210.115 173.5 212.157 175.644 214.897 175.644C217.637 175.644 219.679 173.5 219.679 170.751V159.629C219.679 158.121 219.283 156.634 218.85 155.251C224.123 153.25 227.783 148.617 227.783 142.39V127.932C227.783 121.811 224.215 116.617 218.874 114.991C219.298 113.631 219.679 112.172 219.679 110.693V96.2341C219.679 89.0361 213.856 83 206.793 83H111.166C104.103 83 98.2798 89.0361 98.2798 96.2341V110.693C98.2798 116.814 101.847 122.007 107.189 123.633C106.765 124.993 106.384 126.452 106.384 127.932V141.278C106.384 142.786 106.78 144.273 107.213 145.656C101.94 147.657 98.2798 152.29 98.2798 158.517V172.976C98.2798 174.484 98.6762 175.971 99.1092 177.354C93.8362 179.355 90.1758 183.988 90.1758 190.215V204.673C90.1758 210.794 93.7433 215.988 99.0845 217.614C98.6612 218.974 98.2798 220.433 98.2798 221.912V236.371C98.2798 242.492 101.847 247.685 107.189 249.311C106.765 250.671 106.384 252.13 106.384 253.61V268.068C106.384 269.576 106.78 271.063 107.213 272.446C101.94 274.448 98.2798 279.081 98.2798 285.307V299.766C98.2798 306.964 104.103 313 111.166 313H304.041C305.487 313 306.699 312.253 307.52 311.239C308.338 310.229 308.823 308.895 308.823 307.551C308.823 304.802 306.782 302.659 304.041 302.659H111.166C109.501 302.659 107.844 301.384 107.844 299.21V284.751C107.844 282.967 109.122 281.302 111.166 281.302H119.81C122.55 281.302 124.592 279.159 124.592 276.41C124.592 273.66 122.55 271.517 119.81 271.517C118.146 271.517 116.488 270.243 116.488 268.068V253.61C116.488 251.826 117.767 250.161 119.81 250.161C122.55 250.161 124.592 248.018 124.592 245.268C124.592 242.441 122.502 240.513 119.65 239.339L119.468 239.263H119.27H111.166C109.501 239.263 107.844 237.989 107.844 235.815V221.356C107.844 219.572 109.122 217.907 111.166 217.907C113.906 217.907 115.948 215.764 115.948 213.015C115.948 210.265 113.906 208.122 111.166 208.122H103.062C101.397 208.122 99.7395 206.847 99.7395 204.673V190.215C99.7395 188.43 101.018 186.766 103.062 186.766H111.166C113.906 186.766 115.948 184.622 115.948 181.873C115.948 179.124 113.906 176.98 111.166 176.98C109.501 176.98 107.844 175.706 107.844 173.532V159.073C107.844 157.289 109.122 155.624 111.166 155.624H119.81C122.55 155.624 124.592 153.481 124.592 150.732C124.592 149.368 124.09 148.122 123.127 147.221C122.168 146.323 120.828 145.839 119.27 145.839C117.605 145.839 115.948 144.564 115.948 142.39V127.932C115.948 125.676 117.688 123.927 119.81 123.927C122.55 123.927 124.592 121.783 124.592 119.034C124.592 116.679 122.392 114.763 119.471 114.162Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M143.583 123.927H206.794C209.434 123.927 211.576 121.881 211.576 119.59C211.576 116.841 209.534 114.697 206.794 114.697H143.583C140.943 114.697 138.801 116.743 138.801 119.034C138.801 121.783 140.842 123.927 143.583 123.927Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M119.809 155.625H186.802C189.543 155.625 191.584 153.482 191.584 150.733C191.584 147.983 189.543 145.84 186.802 145.84H119.809C117.069 145.84 115.027 147.983 115.027 150.733C115.027 153.482 117.069 155.625 119.809 155.625Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M195.319 182.738L195.367 182.588V182.43C195.367 179.681 193.326 177.537 190.585 177.537H133.317C130.577 177.537 128.535 179.681 128.535 182.43C128.535 185.179 130.577 187.322 133.317 187.322H190.585C191.834 187.322 192.897 186.495 193.631 185.664C194.396 184.797 195.006 183.704 195.319 182.738Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M111.167 218.463H164.113C166.853 218.463 168.895 216.32 168.895 213.57C168.895 210.821 166.853 208.678 164.113 208.678H111.167C108.426 208.678 106.385 210.821 106.385 213.57C106.385 216.32 108.426 218.463 111.167 218.463Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M144.122 250.16H173.296C176.037 250.16 178.078 248.017 178.078 245.268C178.078 242.518 176.037 240.375 173.296 240.375H144.122C141.381 240.375 139.34 242.518 139.34 245.268C139.34 248.017 141.381 250.16 144.122 250.16Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M119.809 281.303H158.708C161.449 281.303 163.49 279.159 163.49 276.41C163.49 273.661 161.449 271.518 158.708 271.518H119.809C117.069 271.518 115.027 273.661 115.027 276.41C115.027 279.159 117.069 281.303 119.809 281.303Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M191.126 237.371H229.485C232.225 237.371 234.266 235.228 234.266 232.479C234.266 229.729 232.225 227.586 229.485 227.586H191.126C188.385 227.586 186.344 229.729 186.344 232.479C186.344 235.228 188.385 237.371 191.126 237.371Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M191.126 267.399H229.485C232.225 267.399 234.266 265.255 234.266 262.506C234.266 259.757 232.225 257.613 229.485 257.613H191.126C188.385 257.613 186.344 259.757 186.344 262.506C186.344 265.255 188.385 267.399 191.126 267.399Z",
    fill: "#84A76A",
    stroke: "#84A76A",
    strokeWidth: 2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_573_74",
    x: 0,
    y: 0,
    width: 392,
    height: 392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_74"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_74",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame3Badge);
export default __webpack_public_path__ + "static/media/game3-badge.9f31db6717bf642320fc9e6ef14f1c3c.svg";
export { ForwardRef as ReactComponent };